<template>
  <notification
    type="is-success"
    icon="fa-check"
    @delete="$emit('delete')"
    :snackbar="5"
  >
    <p>
      Pol{{ multiple ? "a" : "e" }}
      <template v-for="(template, index) in templatesArray">
        <strong :key="template">{{ fields[template] }}</strong>
        <template v-if="index < templatesArray.length - 2"
          >,
        </template>
        <template v-else-if="index === templatesArray.length - 2">
          oraz
        </template>
      </template>
      został{{ multiple ? "y" : "o" }} zaktualizowane.
    </p>
  </notification>
</template>

<script>
import { Notification } from "%notifications";

export default {
  name: "templates-updated-notification",

  components: {
    Notification
  },

  props: {
    templates: Object,
    fields: Object
  },

  computed: {
    multiple() {
      return this.templates.length > 1;
    },

    templatesArray() {
      return Object.keys(this.templates);
    }
  }
};
</script>

<style></style>
